/**
 * 모달창이 열리면, scroll bar를 유지하며 body의 위치를 고정합니다.
 * @returns {object} 스크롤 방지 및 복구 함수
 */
const useModalScroll = () => {
  const preventScroll = () => {
    const currentScrollY = window.scrollY;
    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    // 스크롤바 너비만큼 패딩 추가
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = `-${currentScrollY}px`;
    document.body.style.paddingRight = `${scrollBarWidth}px`; // 스크롤바 너비만큼 패딩 추가
    document.body.style.overflow = "hidden";

    return currentScrollY;
  };

  const allowScroll = (prevScrollY) => {
    document.body.style.position = "";
    document.body.style.width = "";
    document.body.style.top = "";
    document.body.style.paddingRight = ""; // 추가했던 패딩 제거
    document.body.style.overflow = ""; // 원래 상태로 복구
    window.scrollTo(0, prevScrollY); // 이전 스크롤 위치로 이동
  };

  return {
    preventScroll,
    allowScroll,
  };
};

export default useModalScroll;
